/**
 * The intro slot dressed as a video call, because that is the thing being sold:
 * every session on the platform is a 1-on-1 call, and a bare poster with a play
 * mark said "a video about this person" instead. Drawn in shapes, never icons —
 * the storefront has none.
 */

function ControlDot({ children }: { children: React.ReactNode }) {
  return (
    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/20">
      {children}
    </span>
  );
}

/**
 * The call window's furniture, dropped into whatever relative box holds the
 * tile. Inert by design: the frame's own button covers the slot, so nothing
 * here may take a tap of its own.
 */
export function CallChrome({ name, playable = false }: { name: string; playable?: boolean }) {
  return (
    <span aria-hidden className="pointer-events-none absolute inset-0">
      <span className="absolute left-2 top-2 rounded-md bg-black/45 px-1.5 py-0.5 text-[10px] font-bold text-white/90 backdrop-blur-sm">
        {name}
      </span>

      {/* The viewer's own tile, the way a call puts you in the corner of it. */}
      <span className="absolute bottom-11 right-2 flex h-9 w-12 items-center justify-center rounded-md border border-white/15 bg-black/55 backdrop-blur-sm">
        <span className="h-3.5 w-3.5 rounded-full bg-white/25" />
      </span>

      <span className="absolute inset-x-0 bottom-0 flex h-10 items-center justify-center gap-2 bg-gradient-to-t from-black/70 to-transparent px-2">
        <ControlDot>
          <span className="h-2.5 w-[7px] rounded-full bg-white/80" />
        </ControlDot>
        <ControlDot>
          <span className="h-2 w-3.5 rounded-[3px] bg-white/80" />
        </ControlDot>
        {playable && (
          <span className="ml-1 rounded-full bg-[var(--sf-lime)] px-3 py-1.5 text-badge font-extrabold text-[var(--sf-on-lime)]">
            Play
          </span>
        )}
      </span>
    </span>
  );
}
